/**
 * @desc 根据仓库编码列表查询真实库存 可用+锁定
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(
  params: API.stock.stockQueryFacadeImpl.getWarehouseSkuRealQtyList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stock/getWarehouseSkuRealQtyList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
